// ── Far-view pipeline switch ─────────────────────────────────────────────────────────────────────────
// The far-view rebuild (mixed atlas, persistent bitmap cache, loader-holds-until-painted) is the
// DEFAULT. Guri's ruling after the flag round: "I'm doing this on the Birtvy, not the farview=next" —
// a gated pipeline he cannot accidentally exercise does not exist for him, so the gate now points the
// other way: `?farview=off` (or localStorage 'birtvy:farview' = 'off') restores the previous pipeline
// for A/B comparison. The old opt-in spellings ('next') still count as ON and are simply redundant.

let cached: boolean | null = null

export function farviewNext(): boolean {
  if (cached !== null) return cached
  if (typeof window === 'undefined') return true // SSR: don't cache — the client decides on mount
  let on = true
  try {
    const q = new URLSearchParams(window.location.search).get('farview')
    const ls = window.localStorage.getItem('birtvy:farview')
    on = q === 'off' ? false : ls === 'off' ? q === 'next' : true
  } catch {
    on = true
  }
  cached = on
  return on
}
